<template>
  <div class="certificate-info">
    <div class="certificate-info__title">Информация о сертификате:</div>
    <ul class="certificate-info__list">
      <template v-for="(item, key) in certInfoTitles">
        <li
          v-if="certificate[key]"
          :key="key"
          class="certificate-info__list-item"
        >
          <span class="certificate-info__list-key">{{ item }}: </span>
          <span> {{ certificate[key] }}</span>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CertificateInfo',
  props: {
    certificate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      certInfoTitles: {
        name: 'Наименование сертификата',
        issuerFull: 'Издатель',
        ownerFull: 'Владелец',
        thumbprint: 'Отпечаток',
        valid: 'Действителен',
      },
    };
  },
};
</script>

<style lang="scss" scoped src="./CertificateInfo.scss" />
